export default __webpack_public_path__ + "static/media/main-banner.9d84f8b1.png";